import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useEffect, useState} from 'react';
import TypewritterEffect from '../TypewritterEffect';
import styles from './ChatBubble.module.scss';

export interface ChatBubbleProps {
  message: string;
  imageUrl?: string;
  variant?:
    | 'avatar'
    | 'character-left'
    | 'character-right'
    | 'character-bottom'
    | 'text-only';
  onClick?(): void;
  onAnimationEnd?(): void;
  onChatEnd?(): void;
  animationBlocked?: boolean;
  clickBlocked?: boolean;
  onCloseButton?(): void;
}

function ChatBubble({
  message,
  imageUrl,
  variant = 'text-only',
  animationBlocked = false,
  onClick,
  onAnimationEnd,
  onChatEnd,
  clickBlocked = false,
  onCloseButton,
}: ChatBubbleProps): JSX.Element {
  const [animationStop, setAnimationStop] = useState(false);

  useEffect(() => {
    if (animationStop && !animationBlocked) {
      setAnimationStop(false);
    }
  }, [message]);

  function handleClick() {
    if (animationStop && !animationBlocked) {
      setAnimationStop(false);
      onClick?.();
      return;
    }
    setAnimationStop(true);
  }

  return (
    <div className={`${styles.wrapper} ${styles[variant]}`}>
      {variant !== 'text-only' && (
        <img
          data-testid="chatBubbleCharacter"
          className={`${styles.image}  ${styles[variant]}`}
          src={imageUrl}
          alt=""
        />
      )}

      {message?.length && (
        <button
          type="button"
          className={`${styles.chatBubble}  ${styles[variant]}`}
          onClick={
            !clickBlocked
              ? handleClick
              : () => {
                  onChatEnd?.();
                  setAnimationStop(true);
                }
          }
          data-testid="chatBubble"
          data-blockclick={clickBlocked}
        >
          {!!onCloseButton && (
            <button
              type="button"
              className={styles.closeButton}
              data-testid="closeButton"
              onClick={onCloseButton}
            >
              <FontAwesomeIcon icon="close" size="xl" />
            </button>
          )}
          <TypewritterEffect
            text={message}
            className={styles.message}
            animation={{
              speed: 1.3,
              stop: animationBlocked || animationStop,
              endCallback: () => {
                setAnimationStop(true);
                onAnimationEnd?.();
              },
            }}
          />
          {!clickBlocked && <FontAwesomeIcon icon="caret-down" size="lg" />}
        </button>
      )}
    </div>
  );
}

export default ChatBubble;
